export default __webpack_public_path__ + "static/media/about_us.3f415998.jpg";